import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import MerchantRegister from "@/pages/MerchantRegister";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import VendorDashboard from "@/pages/vendor/VendorDashboard";
import EmployeeDashboard from "@/pages/employee/EmployeeDashboard";
import MerchantDashboard from "@/pages/merchant/MerchantDashboard";

const RoleRoute = ({ allow, children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (allow && !allow.includes(user.role)) return <Navigate to={`/${user.role}`} replace />;
  return children;
};

const RoleRedirect = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={`/${user.role}`} replace />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<MerchantRegister />} />
          <Route path="/dashboard" element={<RoleRedirect />} />
          <Route
            path="/admin/*"
            element={<RoleRoute allow={["admin"]}><AdminDashboard /></RoleRoute>}
          />
          <Route
            path="/vendor/*"
            element={<RoleRoute allow={["vendor"]}><VendorDashboard /></RoleRoute>}
          />
          <Route
            path="/employee/*"
            element={<RoleRoute allow={["employee"]}><EmployeeDashboard /></RoleRoute>}
          />
          <Route
            path="/merchant/*"
            element={<RoleRoute allow={["merchant"]}><MerchantDashboard /></RoleRoute>}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
